import { useEffect, useState } from 'react';

const SCROLL_THRESHOLD = 20; // Page Y scroll offset

export default (threshold = SCROLL_THRESHOLD, onlyInitial = false) => {
  const [isScrolled, setIsScrolled] = useState(false);

  // scroll event listener
  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    window.addEventListener('resize', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', handleScroll);
    };
  }, []);

  const handleScroll = () => {
    if (window && window.scrollY > threshold) {
      setIsScrolled(true);
    } else {
      !onlyInitial && setIsScrolled(false);
    }
  };

  return isScrolled;
};
